import React from 'react'

import classNames from 'classnames'

const tabHeaderRenderer = (activeTab, setState, secondary) => (tab) => {
  if (
    tab.props &&
    typeof (tab.props.title) !== 'undefined' &&
    typeof (tab.props.eventKey) !== 'undefined'
  ) {
    const selected = activeTab && tab.props.eventKey === activeTab.props.eventKey
    const classes = classNames(
      'tab-header',
      secondary ? 'secondary' : 'main',
      selected ? 'selected' : null,
      tab.props.disabled ? 'is-disabled' : null
    )
    return (
      <div
        data-id={tab.props.eventKey}
        key={tab.props.eventKey}
        className={classes}
        disabled={tab.props.disabled}
        onClick={() => {
          if (!tab.props.disabled) {
            setState({activeKey: tab.props.eventKey})
          }
        }}
      >
        <span className='tab-header-text'>{tab.props.title}</span>
      </div>
    )
  } else {
    return tab
  }
}

const findActiveTab = (children, activeKey) => {
  const tabs = React.Children.toArray(children)
  const activeTab = tabs
  .filter(tab => tab.props && tab.props.eventKey && !tab.props.disabled)
  .find((tab) => tab.props.eventKey === activeKey)
  return activeTab ||
    tabs
    .find(tab => tab.props && typeof tab.props.eventKey !== 'undefined' && !tab.props.disabled)
}

export default class Tabs extends React.Component {
  constructor (props) {
    super(props)
    this.state = {activeKey: props.activeKey}
  }
  componentWillReceiveProps (props) {
    this.setState({activeKey: props.activeKey})
  }

  render () {
    const activeTab = findActiveTab(this.props.children, this.state.activeKey)
    const renderTabHeader = tabHeaderRenderer(activeTab, (state) => {
      const onTabChange = this.props.onTabChange
      if (onTabChange) onTabChange(state.activeKey)
      this.setState(state)
    }, this.props.secondary)
    const tabs = React.Children.map(
      this.props.children,
      (child) => renderTabHeader(child)
    )
    const classes = classNames(
      'nmc-tabs',
      this.props.secondary ? 'secondary' : 'main'
    )
    return (
      <div className={classes}>
        <div className='tabs-headers-container'>{tabs}</div>
        {activeTab}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Tabs/Tabs.js